export const plateTypes = {

    "fluver": "fluver",
    "dyecal": "dyecal",
    "eva": "eva",
    "probes:": "probes",
    "mfg": "mfg",
    "qc": "qc"
};